import { Button, Icon, Popover, StatusIndicator } from '@amzn/awsui-components-core';
import React, { useContext, useState } from 'react';
import { AppContext } from '../../contexts/AppContext';

interface CopyFinalizingLinkButtonProps {
  contentId: string;
  workflowId: number;
}

export const CopyFinalizingLinkButton = (props: CopyFinalizingLinkButtonProps) => {
  const appCtx = useContext(AppContext);

  const [copied, setCopied] = useState(false);

  if (!appCtx.isAuthenticated) {
    return null;
  }

  const copyLinkToClipboard = () => {
    let hostname = window?.location?.hostname;
    if (window?.location?.port !== undefined && window?.location?.port !== '443') {
      hostname += `:${window.location.port}`;
    }
    const { contentId, workflowId } = props;
    // @ts-expect-error TS18048 - strict migration
    const { userId } = appCtx.authnInfo.userProfile;
    navigator.clipboard.writeText(
      `https://${hostname}/content-finalizing-viewer/author/${contentId}/${workflowId}/${userId}`,
    );
    setCopied(true);
  };

  const popoverStatusContent = <StatusIndicator type="success">Link copied</StatusIndicator>;

  return (
    <Popover
      triggerType="custom"
      content={popoverStatusContent}
      position="top"
      dismissButton={false}
    >
      <Button variant="normal" onClick={copyLinkToClipboard}>
        <Icon variant="normal" name="copy" /> Copy Link
      </Button>
    </Popover>
  );
};
